import i18n from '@src/common/lib/i18n'
const DIC = {
  isIndoorList: [{
    label: "是",
    value: "1"
  }, {
    label: "否",
    value: "0"
  }],
  stateList: [{
    label: "在线",
    value: "1"
  }, {
    label: "离线",
    value: "0"
  },
  {
    label: "故障",
    value: "2"
  }],
}
export const editDev = function (that) {
  return {
    menuBtn: false,
    column: [{
      label: '设备名称',
      prop: 'thirdDeviceName',
      clearable: false,
      rules: [{
        required: true,
        message: that.$t('cameraList.placeholder.enterName'),
        trigger: 'change'
      },
      {
        min: 1,
        max: 64,
        message: that.$t('cameraList.placeholder.lengthLess'),
        trigger: 'change'
      }
      ]
    },
    {
      label: "第三方设备ID",
      prop: 'thirdDeviceId',
      placeholder: '请输入第三方设备ID',
      labelWidth: 100,
      clearable: false,
    },
    {
      label: "设备状态",
      prop: 'status',
      type: 'select',
      disabled: true,
      dicData: DIC.stateList,
      rules: [{
        required: true,
        message: "请选择",
        trigger: 'change'
      },],
      mock: {
        type: 'dic'
      }
    },
    // {
    //   label: "是否室内",
    //   prop: 'isIndoor',
    //   type: 'select',
    //   labelWidth: 100,
    //   formslot: true,
    //   rules: [{
    //     required: true,
    //     message: "请选择",
    //     trigger: 'change'
    //   },],
    // },
    // {
    //   label: that.$t('cameraList.label.lng'),
    //   prop: 'longitude',
    //   labelWidth: 100,
    //   formslot: true,
    //   clearable: true,
    //   rules: [{
    //     required: true,
    //     message: that.$t('cameraList.placeholder.enterLng'),
    //     trigger: 'change'
    //   },
    //   {
    //     pattern: /^[-+]?(0?\d{1,2}|0?\d{1,2}\.\d{1,10}|1[0-7]?\d{1}|1[0-7]?\d{1}\.\d{1,10}|180|180\.0{1,10})$/,
    //     message: that.$t('cameraList.message.numberMorn'),
    //     trigger: 'change'
    //   }
    //   ]
    // },
    // {
    //   label: that.$t('cameraList.label.lat'),
    //   prop: 'latitude',
    //   labelWidth: 100,
    //   formslot: true,
    //   clearable: true,
    //   rules: [{
    //     required: true,
    //     message: that.$t('cameraList.placeholder.enterLat'),
    //     trigger: 'change'
    //   },
    //   {
    //     pattern: /^[-+]?([0-8]?\d{1}|[0-8]?\d{1}\.\d{1,10}|90|90\.0{1,10})$/,
    //     message: that.$t('cameraList.message.numberMorns'),
    //     trigger: 'change'
    //   }
    //   ]
    // },
    {
      label: "所属楼栋",
      prop: 'buildName',
      formslot: true,
    },
    {
      label: "所属楼层",
      prop: 'floorName',
      formslot: true,
    },
    // {
    //   label: "横坐标",
    //   prop: 'abscissa',
    //   labelWidth: 100,
    //   disabled: true,
    //   placeholder: ' ',
    // },
    // {
    //   label: "纵坐标",
    //   prop: 'ordinate',
    //   labelWidth: 100,
    //   disabled: true,
    //   placeholder: '',

    // },
    // 以及属性 可改
    {
      label: "厂商名称",
      prop: 'zBusinessName',
      placeholder: '请输入厂商名称 '
    },
    {
      label: "固件版本",
      prop: 'zGVersion',
      placeholder: '请输入固件版本'
    },
    // {
    //   label: "软件版本",
    //   prop: 'zSVersion',
    //   span: 8,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "信号强度",
    //   prop: 'zSmeter',
    //   span: 8,
    //   labelWidth: 100,
    //   placeholder: '请输入 ',
    // },
    // {
    //   label: "小区IDinteger",
    //   prop: 'zIDinteger',
    //   span: 8,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "接收信号强度",
    //   prop: 'zJmeter',
    //   labelWidth: 100,
    //   span: 8,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "信噪比",
    //   prop: 'zSnr',
    //   span: 8,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "信号发射强度",
    //   prop: 'zFmeter',
    //   span: 8,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "小区覆盖等级",
    //   prop: 'zGrade',
    //   span: 8,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "电池容量",
    //   prop: 'zBattery',
    //   span: 8,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "通讯重连次数",
    //   prop: 'zLinkNum',
    //   labelWidth: 100,
    //   span: 8,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "通讯重连时间",
    //   prop: 'zLinkTime',
    //   labelWidth: 100,
    //   span: 8,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "报警时间/s",
    //   span: 8,
    //   prop: 'zAlarmTime',
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "心跳时间/s",
    //   prop: 'zHeartTime',
    //   span: 8,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "欠压状态",
    //   prop: 'zStates',
    //   span: 8,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "电池欠压幅值",
    //   prop: 'zRange',
    //   span: 8,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "设置报警时间",
    //   prop: 'zSetTime',
    //   span: 8,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "设置电池欠压",
    //   prop: 'zSetStress',
    //   span: 8,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "设置心跳时间",
    //   prop: 'zSetHeartTime',
    //   labelWidth: 100,
    //   span: 8,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "设置重连时间",
    //   prop: 'zSetLinkTime',
    //   span: 8,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    // {
    //   label: "设置重连次数",
    //   prop: 'zSetLinkNum',
    //   span: 8,
    //   labelWidth: 100,
    //   placeholder: '请输入 '
    // },
    {
      label: "设备描述",
      type: 'textarea',
      prop: 'thirdDeviceDesc',
      minRows: 3,
      maxlength: 120,
      span: 24,
      clearable: true,
      placeholder: '请输入设备描述'
    }
    ]
  }
}
